import { ajax } from 'rxjs/ajax'

export const get = (url, token) => {
  return ajax({
    method: 'GET',
    crossDomain: true,
    url,
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'json'
  })
}

export const put = (url, token, body) => {
  return ajax({
    method: 'PUT',
    crossDomain: true,
    url,
    body: JSON.stringify(body),
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    responseType: 'json'
  })
}

export const del = (url, token) => {
  return ajax({
    method: 'DELETE',
    crossDomain: true,
    url,
    headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    responseType: 'json'
  })
}

export const post = (url, token, body) => {
  return ajax({
    method: 'POST',
    crossDomain: true,
    url: url,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    responseType: 'json'
  })
}



// WEBPACK FOOTER //
// ./src/ajax/ptbAjax.js